import React, { useEffect, useState } from "react";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`lawgis-scrolltop ${visible ? "scrolltop-show" : "scrolltop-hide"}`}
      onClick={scrollUp}
    >
      <i className="ti ti-arrow-up"></i>
    </button>
  );
}

export default ScrollToTop;
